import { types } from "../types/types";

const initialState = {
    searchText: '',
    page: 0,
    itemsPerPage: 9,
    catalogsToFilter: [],
    indicatorsToFilter: [],
    catalogModule:{},
    catalogCiiuLevel1:{},
    groupVision:{},
    concern:{}

};
export const searchHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case types.SET_PREVIOUS_SEARCH_PARAMS:

    //console.log("1111, SET_PREVIOUS_SEARCH_PARAMS, action.payload", action.payload)
      return {
        ...state,
        ...action.payload
      };

    case types.SET_CURRENT_SEARCH_PARAMS:

    //console.log("1111, SET_CURRENT_SEARCH_PARAMS, action.payload", action.payload)
      return {
        ...state,
        ...action.payload
      };

     case types.CLEAN_SEARCH_PARAMS:

    //console.log("1111, CLEAN_SEARCH_PARAMS")
      return {
        ...state,
        searchText: '',
        page: 0,
        itemsPerPage: 9,
        catalogsToFilter: [],
        indicatorsToFilter: [],
        catalogModule:{},
        catalogCiiuLevel1:{},
        groupVision:{},
        concern:{}
      };

      case types.CLEAN_SEARCH_PARAMS_NO_MODULE:

    //console.log("1111, CLEAN_SEARCH_PARAMS_NO_MODULE")
      return {
        ...state,
        searchText: '',
        page: 0,
        itemsPerPage: 9,
        catalogsToFilter: [],
        indicatorsToFilter: [],
        //catalogModule:{},
        catalogCiiuLevel1:{},
        groupVision:{},
        concern:{}
      };

    default:
      return state;
  }
};